import { submit } from 'redux-form'
import { Button } from '../common'
import { DisplaySavedReshipmentItems } from '.'
import { getReshipmentSavingData, getReshipmentSavingStatusProps } from '../../selectors/reshipment'
import {
  RESHIPMENT_FORM_NAME,
  APPROVAL_PENDING,
  NEED_INFO,
  PENDING_SUBMISSION,
  STATUS_DESCRIPTIONS,
} from '../../constants/ReshipmentConstants'

const mapStateToProps = state => {
  const { saving, fetching, error } = getReshipmentSavingStatusProps(state)
  const { name, lastUpdated, status, data } = getReshipmentSavingData(state)
  const savedTestWindows = Object.keys(data)
  const noItems = savedTestWindows.length === 0
  return {
    name,
    lastUpdated,
    status,
    noItems,
    data,
    busy: saving || fetching,
    error,
  }
}

export default connect(mapStateToProps, { submit })(
  ({ name, lastUpdated, status, noItems, data, busy, error, submit }) => {
    return (
      <div
        aria-live="polite"
        style={{ border: '1px solid #ccc', backgroundColor: '#eee', padding: '8px' }}
      >
        <div>
          <h3 style={{ marginBottom: 0 }}>{name || 'New Reshipment'}</h3>
          {status !== null && status !== PENDING_SUBMISSION && (
            <div style={{ fontSize: '.9em' }}>
              <div style={{ fontWeight: 'bold' }}>Status: {STATUS_DESCRIPTIONS[status]}</div>
              <div style={{ fontStyle: 'italic' }}>Last modified: {lastUpdated}</div>
            </div>
          )}
        </div>
        <div style={{ marginTop: '1em' }}>
          <DisplaySavedReshipmentItems data={data} busy={busy} error={error} />
        </div>
        <div style={{ textAlign: 'right', marginTop: '1em' }}>
          <Button
            isSubmit={true}
            isPrimary={true}
            isDisabled={noItems || busy || status === APPROVAL_PENDING || status === NEED_INFO}
            busy={busy}
            style={{ marginLeft: 'auto' }}
            onClick={() => submit(RESHIPMENT_FORM_NAME)}
          >
            {status === null || status === PENDING_SUBMISSION ? 'Submit' : 'Update'}
          </Button>
        </div>
      </div>
    )
  }
)
